import { createAction, props } from '@ngrx/store';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

export const ForgotPasswordActionTypes = {
  CAPTCHA: '[Forgot Password Page] Captcha',
  REQUEST_LINK: '[Forgot Password Page] Request Link',
  REQUEST_LINK_ERROR: '[Forgot Password Page] Request Link Error',
  REQUEST_LINK_SUCCESS: '[Forgot Password Page] Request Link Success',
  REQUEST_RESET: '[Forgot Password Page] Request Reset',
  REQUEST_RESET_ERROR: '[Forgot Password Page] Request Reset Error',
  REQUEST_RESET_SUCCESS: '[Forgot Password Page] Request Reset Success'
};

export const ForgotPasswordCaptchaAction = createAction(
  ForgotPasswordActionTypes.CAPTCHA, 
  props<{}>()
);

export const ForgotPasswordRequestLinkAction = createAction(
  ForgotPasswordActionTypes.REQUEST_LINK,
  props<{ captcha: string; email: string }>()
);

export const ForgotPasswordRequestLinkSuccessAction = createAction(
  ForgotPasswordActionTypes.REQUEST_LINK_SUCCESS,
  props<{ response: ApiResponseSimple }>()
);

export const ForgotPasswordRequestLinkErrorAction = createAction(
  ForgotPasswordActionTypes.REQUEST_LINK_ERROR,
  props<{}>()
);

export const ForgotPasswordRequestResetAction = createAction(
  ForgotPasswordActionTypes.REQUEST_RESET,
  props<{ captcha: string; token: string; password: string }>()
);

export const ForgotPasswordRequestResetSuccessAction = createAction(
  ForgotPasswordActionTypes.REQUEST_RESET_SUCCESS,
  props<{ response: ApiResponseSimple }>()
);

export const ForgotPasswordRequestResetErrorAction = createAction(
  ForgotPasswordActionTypes.REQUEST_RESET_ERROR,
  props<{}>()
);
